angular.module('impactx.list').controller('ListFilterCtrl', ListFilterCtrl);

ListFilterCtrl.$inject = ['$scope', 'TranslationService'];

function ListFilterCtrl($scope, TranslationService) {
    $scope.inputFocused = false;

    $scope.changeInputFocus = function () {
        $scope.inputFocused = !$scope.inputFocused;
    };

    $scope.orLabel = TranslationService.get("or");

}